<div style="width: 100%; background-color: #ffffff;">
    <div style="width: 100%; background-color: #f5f5f5; margin: 0 auto; padding: 0.5rem 0;">
        <p style="text-align: center; color: #A1A1A1; font-weight: 600;">TRUSTED PARTNERS</p>
        <div class="trusted-partners-container">
            <div class="trusted-partners">
                <!-- Add in  multiple groups of pictures because it allows the carousel to work at all sizes -->
                <app-trusted-partner *ngFor="let partner of partnersData" [partnerUrl]="partner.partnerUrl"
                    [partnerAlt]="partner.partnerAlt" [imgSrc]="partner.imgSrc"></app-trusted-partner>
            </div>
        </div>
    </div>
</div>